<template>
  <DxTabPanel
    :element-attr="tabPanelAttributes"
    :data-source="receptionSteps"
    :loop="false"
    :selected-index="currentStep"
    :animation-enabled="true"
    :swipe-enabled="false"
    :show-nav-buttons="false"
    @selection-changed="tabSelectionChanged($event)"
  >
    <template #item="{ data: step }">
      <div>
        <div v-if="step == 1" class="filter_container" :use-native="true">
          <DxScrollView ref="receptionInputScroll" v-show="step == 1" class="reception-input-scroll" :use-native="true">
            <div class="reception_input_holder" :class="[{ input_holder_error: $v.receptionData.reception_date.$error }]">
              <div @click="showCalendarSelector">
                <div class="input_label">{{ $t("common.date") }}</div>
                <div class="input_value">
                  <span>{{ receptionData.reception_date }}</span>
                </div>
              </div>
              <div v-if="is_date_selector_visible">
                <FunctionalCalendar
                  :date-format="getDefaultDateFormat.toLowerCase()"
                  :is-date-range="false"
                  v-model="calendarData"
                  :change-month-function="true"
                  :change-year-function="true"
                  :is-date-picker="true"
                  @choseDay="calendarDayChosen"
                  @input="onDateSelected"
                ></FunctionalCalendar>
              </div>
            </div>
            <div
              class="reception_input_holder"
              @click="ordersClick()"
              :class="[{ input_holder_error: isOrderSelectionMandatory && !selectedOrders.length }]"
            >
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">{{ $t("stock_management.orders.order_number") }}</div>
                  <div v-if="selectedOrders.length" class="input_value">{{ getSelectedOrders }}</div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">
                    {{
                      isOrderSelectionMandatory ? $t("stock_mobile.form.required_order_selection") : $t("stock_mobile.form.select_order")
                    }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon" @click="ordersClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder" @click="contractsClick()">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">{{ $t("stock_mobile.form.contract_number") }}</div>
                  <div v-if="selectedContracts.length > 0" class="input_value">{{ getSelectedContracts }}</div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">
                    {{ $t("stock_mobile.form.select_contract") }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon" @click="contractsClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div
              class="reception_input_holder consum_tabs"
              @click="showProductSelector()"
              :class="[{ input_holder_error: $v.receptionData.products.$error }]"
            >
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">{{ $t("common.product") }}</div>
                  <div v-if="receptionData.products.length > 0" class="input_value">{{ getSelectedProduse() }}</div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">
                    {{ $t("stock_mobile.form.select_product") }}
                  </div>
                  <div class="reception_input_second_value">
                    {{
                      receptionData.products.length > 2
                        ? $t("stock_mobile.form.more_products_count", { count: receptionData.products.length - 2 })
                        : ""
                    }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info" @click="partnerClick()">
                  <div class="input_label">{{ $t("stock_mobile.form.supplier") }}</div>
                  <div v-if="selectedPartners.length > 0" class="input_value">
                    {{ getSelectedPartnersNames }}
                  </div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">
                    {{ $t("stock_mobile.form.select_supplier") }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon" @click="partnerClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder" :class="[{ input_holder_error: $v.receptionData.warehouse.uuid.$error }]">
              <div class="input_label">{{ $t("common.warehouse") }}</div>
              <div class="input_value">
                <DxSelectBox
                  v-model="receptionData.warehouse.uuid"
                  :search-enabled="false"
                  search-mode="contains"
                  search-expr="name"
                  class="input_value dx_input_value"
                  :placeholder="$t('stock_mobile.form.select_warehouse')"
                  :data-source="warehouses"
                  :display-expr="warehouseDisplayExpr"
                  value-expr="uuid"
                  :show-clear-button="false"
                  drop-down-button-template="imageIcon"
                  @value-changed="onWarehouseChanged"
                  :disabled="false"
                >
                  <template #imageIcon>
                    <div>
                      <div class="dx_combo_open_button" v-show="!receptionData.warehouse.uuid || receptionData.warehouse.uuid == ''">
                        <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
                      </div>
                      <div class="dx_combo_open_button" v-show="receptionData.warehouse.uuid && receptionData.warehouse.uuid.length > 0">
                        <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
                      </div>
                    </div>
                  </template>
                  <template #item="{ data }">
                    <div class="dx_custom_combo_item">
                      {{ data.name }}{{ data.department?.name ? " (" + data.department.name + ")" : "" }}
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="input_label">{{ $t("stock_mobile.form.shipping_note_number") }}</div>
              <div class="input_value">
                <DxTextBox
                  v-model="receptionData.shipping_note_number"
                  :placeholder="$t('stock_mobile.form.enter_shipping_note_number')"
                  class="global_dx_textbox"
                />
              </div>
            </div>
            <div class="input-bottom-spacer"></div>
          </DxScrollView>
        </div>
        <div v-if="step == 3" class="reception_step_map">
          <ContractsPurchaseSaleSelector
            v-if="step == 3"
            :multiselect="true"
            :selectedContracts.sync="selectedContracts"
            :filterData="{
              contract_type_id: '1',
              show_completed_rows: 0,
              sale_type: 'partner',
            }"
            :toastMessageRef="$refs.toastMessage"
          />
        </div>
        <div v-if="step == 4" class="reception_step_map">
          <OrdersSelectorMobile
            v-if="step == 4"
            :multiselect="true"
            :selectedOrders.sync="selectedOrders"
            :toastMessageRef="$refs.toastMessage"
            :filterData="{
              order_type_id: '1',
            }"
          />
        </div>
        <div v-if="step == 5" class="reception_step_map">
          <PartnerSelector
            v-if="step == 5"
            :allowAddNew="true"
            :multiselect="false"
            :selectedPartners.sync="selectedPartners"
            :toastMessageRef="$refs.toastMessage"
          />
        </div>
        <div v-if="false" v-show="step == 2" class="scanner_area">
          <div>{{ $t("common.feature_in_development") }}</div>
          <br />
          <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader><br />
          <div>{{ $t("stock_mobile.form.scanned_code") }}</div>
          <b></b>
          <div>{{ scannedCode }}</div>
        </div>
        <div class="reception_bottom_sticky" v-show="step == 3 && selectedContracts.length > 0">
          <div class="sticky_action_button" @click="continueFromSelection">{{ $t("common.continue") }}</div>
        </div>
        <div class="reception_bottom_sticky" v-show="step == 4 && selectedOrders.length > 0">
          <div class="sticky_action_button" @click="continueFromOrderSelection">{{ $t("common.continue") }}</div>
        </div>
        <div class="reception_bottom_sticky" v-show="step == 5 && selectedPartners.length > 0">
          <div class="sticky_action_button" @click="continueFromPartnerSelection">{{ $t("common.continue") }}</div>
        </div>
        <div class="reception_bottom_sticky_two_line" v-show="step == 1 && showSaveButtons && !saveButtonPressed">
          <div style="display: flex; flex-direction: row; width: 100%">
            <div class="sticky_action_button" style="margin-right: 6px" @click="saveReception(true, false)">
              {{ $t("stock_mobile.form.save_and_new_reception") }}
            </div>
            <div class="sticky_action_button" style="margin-left: 6px" @click="saveReception(false, true)">
              {{ $t("stock_mobile.form.save_and_consumption") }}
            </div>
          </div>
          <div class="sticky_action_button_second" @click="saveReception(false, false)">{{ $t("common.save") }}</div>
        </div>
        <ProductSelector
          ref="productSelector"
          :showPopup="productSelectorVisibility"
          @hidden="hideProductSelector"
          :selectedProducts="receptionData.products"
          :isProductEditable="selectedContracts.length > 0 || selectedOrders.length > 0 ? false : true"
          :transactionType="transactionTypeTitle"
        >
        </ProductSelector>
        <toast-message ref="toastMessage"></toast-message>
      </div>
    </template>
  </DxTabPanel>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTabPanel from "devextreme-vue/tab-panel";
import { DetailCodes, InputDetailCodes } from "./reception.js";
import { required, helpers } from "vuelidate/src/validators";
import DxTextBox from "devextreme-vue/text-box";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxSelectBox from "devextreme-vue/select-box";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import DxTextArea from "devextreme-vue/text-area";
import { StreamBarcodeReader } from "vue-barcode-reader";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import ProductSelector from "../Product/ProductSelector.vue";
import ContractsPurchaseSaleSelector from "@/components/Mobile/ContractsPurchaseSaleSelector.vue";
import OrdersSelectorMobile from "@/components/Mobile/OrdersSelectorMobile.vue";
import PartnerSelector from "@/components/Mobile/PartnerSelector.vue";
import { TransactionActions, TransactionOptions } from "../transactions.js";

const requiredByParam = (param) => (value) => {
  if (param) {
    return helpers.req(value) && value.length > 0;
  }
  return true;
};

const requiredByParamNumber = (value) => {
  return helpers.req(value) && value > 0;
};

export default {
  name: "Reception",
  data() {
    return {
      preselectDate: true,
      calendarData: {},
      receptionSteps: [1, 2, 3, 4, 5],
      currentStep: 0,
      currentItem: 1,
      tabPanelAttributes: {
        class: "reception_tabs",
      },
      detailStepCode: "",
      detailInputStepCode: "",
      receptionData: {
        products: [],
        partner: {
          uuid: "",
          name: "",
          id_number: "",
        },
        warehouse: {
          uuid: "",
          name: "",
        },
        reception_date: null,
        shipping_note_number: null,
      },
      warehouses: [],
      scannedCode: null,
      is_date_selector_visible: false,
      productSelectorVisibility: false,
      saveButtonPressed: false,
      selectedContracts: [],
      selectedPartners: [],
      selectedOrders: [],
      isOrderSelectionMandatory: false,
    };
  },
  computed: {
    ...mapGetters({
      getDefaultDateFormat: "settings/getDefaultDateFormat",
      measureUnits: "measureUnits/measureUnits",
    }),
    transactionTypeTitle() {
      return TransactionOptions.find((opt) => opt.code === TransactionActions.Receptie)?.title || "";
    },
    showSaveButtons() {
      return (
        this.receptionData.products.length > 0 &&
        this.receptionData.partner.uuid &&
        this.receptionData.partner.uuid.length > 0 &&
        this.receptionData.warehouse.uuid &&
        this.receptionData.warehouse.uuid.length > 0
      );
    },
    detailCodes() {
      return DetailCodes;
    },
    inputDetailCodes() {
      return InputDetailCodes;
    },
    getSelectedContracts() {
      if (this.selectedContracts && this.selectedContracts.length > 0) {
        const uniqueNumbers = [...new Set(this.selectedContracts.map((c) => c.contract_number))];
        return uniqueNumbers.join(", ");
      }
      return "";
    },
    getSelectedOrders() {
      if (this.selectedOrders && this.selectedOrders.length > 0) {
        const uniqueNumbers = [...new Set(this.selectedOrders.map((order) => order.order_number))];
        return uniqueNumbers.join(", ");
      }
      return "";
    },
    getSelectedPartnersNames() {
      return this.selectedPartners.map((l) => l.name).join(", ");
    },
  },
  validations() {
    return {
      receptionData: {
        reception_date: { required },
        products: {
          required,
          $each: {
            quantity: { requiredByParamNumber },
          },
        },
        partner: {
          uuid: { required },
        },
        warehouse: {
          uuid: { required },
        },
        reception_date: { required },
      },
    };
  },
  components: {
    DxTabPanel,
    DxTextBox,
    DxScrollView,
    DxSelectBox,
    ToastMessage,
    DxTextArea,
    StreamBarcodeReader,
    FunctionalCalendar,
    ProductSelector,
    ContractsPurchaseSaleSelector,
    OrdersSelectorMobile,
    PartnerSelector,
  },
  /*watch: {
    selectedContracts: {
      handler(newVal) {
        console.log("Selected contracts changed:", newVal);
      },
      immediate: true,
    },
  },*/
  methods: {
    warehouseDisplayExpr(item) {
      if (!item) return "";
      return item.department?.name ? `${item.name} (${item.department.name})` : item.name;
    },
    ...mapActions({
      getWarehouses: "smWarehouses/getSmWarehouses",
      createSmProduct: "smProducts/createSmProduct",
      createReception: "smTransactions/createReceptionTransaction",
      getGroupByCode: "settings/getGroupByCode",
      checkReceptionShippingNumberAlreadyExists: "smTransactions/checkReceptionShippingNumberAlreadyExists",
      getMeasureUnits: "measureUnits/searchMeasureUnits",
    }),

    onLoaded() {},
    onDecode(result) {
      this.scannedCode = result;
    },
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.receptionSteps.indexOf(this.currentItem);
      this.changeAddButtonVisibility();
    },
    goBack() {
      if (this.currentStep > 0) {
        this.currentStep = 0;
        this.setTitle();
      } else {
        this.$emit("goBackParent");
      }
    },
    getCurrentStep() {
      return this.currentStep;
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("stock_mobile.form.product_reception"), true);
      } else if (this.currentStep == 1) {
        this.$emit("setTitle", this.$t("stock_mobile.form.products_list"), false);
      } else if (this.currentStep == 2) {
        this.$emit("setTitle", this.$t("stock_mobile.form.contracts"), true);
      } else if (this.currentStep == 3) {
        this.$emit("setTitle", this.$t("stock_management.orders.title"), true);
      } else if (this.currentStep == 4) {
        this.$emit("setTitle", this.$t("stock_mobile.form.suppliers"), true);
      }
    },
    changeAddButtonVisibility() {
      //this.$emit('changeAddButtonVisibility', this.currentStep == 1 && this.detailStepCode != this.detailCodes.Warehouse);
      this.$emit("changeAddButtonVisibility", false);
    },
    ordersClick() {
      /*if (this.selectedContracts.length > 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_cannot_select_orders_after_contracts"));
        return;
      }*/
      this.currentStep = 3;
      this.setTitle();
    },
    async continueFromOrderSelection() {
      this.currentStep = 0;
      this.setTitle();

      if (!this.selectedOrders.length) {
        return;
      }

      if (!this.measureUnits.length) {
        await this.getMeasureUnits({ enablePagination: 0, limit: 1000 });
      }

      this.selectedOrders.forEach((order) => {
        const existingProduct = this.receptionData.products.find((product) => product.uuid === order.product_uuid);
        const measureUnitId = order.measure_unit_id || order.measure_unit?.id || null;
        const measureUnit = this.measureUnits.find((unit) => unit.id === measureUnitId) || null;

        if (order.product_uuid && !existingProduct) {
          this.receptionData.products.push({
            uuid: order.product_uuid,
            name: order.product_name,
            code: order.product_code,
            barcode: order.product_barcode,
            product_type_uuid: order.product_type_uuid,
            quantity: 0,
            contract_uuid: order.contract_uuid || null,
            order_uuid: order.order_uuid || order.uuid,
            unit_price: parseFloat(order.unit_price_discounted || order.unit_price || 0),
            measure_unit_id: measureUnitId,
            measure_unit: measureUnit,
          });
        } else if (existingProduct) {
          existingProduct.contract_uuid = order.contract_uuid || null;
          existingProduct.order_uuid = order.order_uuid || order.uuid;
          if (!existingProduct.measure_unit && measureUnit) {
            existingProduct.measure_unit = measureUnit;
            existingProduct.measure_unit_id = measureUnitId;
          }
        }

        if (order.contract_uuid) {
          const contract = {
            uuid: order.contract_uuid,
            contract_number: order.contract_number,
            product_uuid: order.product_uuid,
            product_name: order.product_name,
            product_barcode: order.product_barcode,
            product_code: order.product_code,
            product_type_uuid: order.product_type_uuid,
            measure_unit_id: order.measure_unit_id,
            partner_uuid: order.partner_uuid,
            partner_name: order.partner_name,
            partner_id_number: order.partner_id_number,
            partner_legal_form: order.partner_legal_form,
            legal_entity_uuid: order.legal_entity_uuid,
            unit_price_discounted: parseFloat(order.unit_price_discounted || order.unit_price || 0),
          };
          const existingContractIndex = this.selectedContracts.findIndex(
            (selectedContract) => (typeof selectedContract === "string" ? selectedContract : selectedContract.uuid) === contract.uuid,
          );

          if (existingContractIndex === -1) {
            this.selectedContracts.push(contract);
          } else if (typeof this.selectedContracts[existingContractIndex] === "string") {
            this.$set(this.selectedContracts, existingContractIndex, contract);
          }
        }
      });

      const order = this.selectedOrders[0];
      this.selectedPartners = [
        {
          uuid: order.partner_uuid,
          name: order.partner_name,
          id_number: order.partner_id_number,
          legal_form: order.partner_legal_form,
        },
      ];
      this.receptionData.partner = { ...this.selectedPartners[0] };
      this.receptionData.warehouse.uuid = null;
    },
    getSelectedProduse() {
      if (this.receptionData.products.length > 0) {
        if (this.receptionData.products.length === 1) {
          return this.receptionData.products[0].name;
        } else if (this.receptionData.products.length > 1) {
          return this.receptionData.products[0].name + ", " + this.receptionData.products[1].name;
        }
      } else {
        return null;
      }
    },
    saveReception(saveAndNew, startConsum) {
      this.saveButtonPressed = true;

      // Check if order selection is mandatory
      if (this.isOrderSelectionMandatory && !this.selectedOrders.length) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.order_selection_mandatory"));
        this.saveButtonPressed = false;
        return;
      }

      this.checkShippingNumberAlreadyExist(() => {
        this.$v.receptionData.$touch();
        if (!this.$v.receptionData.$invalid) {
          const lotSumInvalid = this.receptionData.products.some((product) => {
            if (!product?.lot_management) {
              return false;
            }
            const items = Array.isArray(product.lot_items) ? product.lot_items : [];
            const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
            const qty = parseFloat(product.quantity) || 0;
            return Math.abs(sum - qty) > 0.0001 || qty <= 0 || items.some((item) => (parseFloat(item.quantity) || 0) <= 0) || sum <= 0;
          });
          if (lotSumInvalid) {
            this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_lot_sum_must_match"));
            this.saveButtonPressed = false;
            return;
          }

          let receptionForSave = {
            department_uuid: this.getWarehouseDepartmentByWarehouseUuid(this.receptionData.warehouse.uuid),
            warehouse_uuid: this.receptionData.warehouse.uuid,
            products: this.receptionData.products,
            reception_date: this.receptionData.reception_date,
            shipping_note_number: this.receptionData.shipping_note_number,
          };

          // remove NEW_ prefix from product uuids for new products and add order/contract uuids
          receptionForSave.products.forEach((product) => {
            if (product.uuid.startsWith("NEW_")) {
              product.uuid = "";
            }
            product.stock_list = undefined;
            product.updated_by = undefined;
            product.partner = undefined;
            product.created_by = undefined;
            product.product_type = undefined;
            product.measure_unit = undefined;
          });

          //--------------------------------------------------------------------------------
          let partnerForSave = {
            uuid: "",
            legal_form: "SRL",
            name: this.receptionData.partner.name,
            id_number: this.receptionData.partner.id_number,
          };
          if (!this.receptionData.partner.uuid.startsWith("NEW_")) {
            partnerForSave.uuid = this.receptionData.partner.uuid;
            partnerForSave.legal_form = this.receptionData.partner.legal_form;
          }

          receptionForSave.partner = partnerForSave;
          //--------------------------------------------------------------------------------

          this.createReception(receptionForSave)
            .then((response) => {
              this.$refs.toastMessage.showSuccess(this.$t("stock_mobile.form.reception_saved"));
              if (saveAndNew && response.data.length > 0) {
                this.resetForm(true);
                this.saveButtonPressed = false;
              } else if (startConsum) {
                let dataForConsum = {
                  ...this.receptionData,
                };

                const responseDataMap = response.data.reduce((map, item) => {
                  map[item.product.uuid] = item.product;
                  return map;
                }, {});

                dataForConsum.products = this.receptionData.products.map((product) => {
                  const productData = responseDataMap[product.uuid] || {};
                  return {
                    uuid: product.uuid,
                    name: product.name,
                    quantity: product.quantity,
                    lot_management: productData.lot_management ?? product.lot_management ?? false,
                    lot_items: Array.isArray(product.lot_items) ? product.lot_items : [],
                    measure_unit: productData.measure_unit,
                    product_type: productData.product_type,
                    stock_list: productData.stock_list,
                  };
                });

                dataForConsum.warehouse_department_legal_entity_uuid = this.getWarehouseDepartmentByWarehouseUuid(
                  this.receptionData.warehouse.uuid,
                  true,
                );

                this.$emit("startConsumFromRecpetion", dataForConsum);
              } else {
                this.closeTransactions(this.$t("stock_mobile.form.reception_saved"));
              }
            })
            .catch((e) => {
              this.saveButtonPressed = false;
              console.log("reception error ", e);
              this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_reception_save_failed"));
            });
        } else {
          this.$refs.toastMessage.showError(this.createErrormMssages());
          this.saveButtonPressed = false;
        }
      });
    },
    checkShippingNumberAlreadyExist(callback) {
      if (this.receptionData.shipping_note_number && this.receptionData.shipping_note_number.length > 0) {
        this.checkReceptionShippingNumberAlreadyExists({
          shipping_note_number: this.receptionData.shipping_note_number,
        }).then((response) => {
          if (response.is_exists) {
            this.$dialog
              .confirm(this.$t("stock_mobile.form.shipping_note_exists_confirm"), {
                okText: this.$t("common.yes"),
                cancelText: this.$t("common.no"),
              })
              .then((dialog) => {
                dialog.close();
                callback();
              })
              .catch(() => {
                // Handle cancel
                this.saveButtonPressed = false;
              });
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    },
    createErrormMssages() {
      let errorMessages = [];

      if (this.receptionData.products.length == 0) {
        errorMessages.push(this.$t("stock_mobile.form.error_product_required"));
      }

      this.receptionData.products.forEach((product, index) => {
        if (!product.measure_unit_id) {
          errorMessages.push(this.$t("stock_mobile.form.error_measure_unit_required", { name: product.name }));
        }
        if (!product.product_type_uuid) {
          errorMessages.push(this.$t("stock_mobile.form.error_product_type_required", { name: product.name }));
        }
        /*if (!product.code) {
            errorMessages.push(`Codul intern al produsului este obligatoriu (${product.name})!`);
        }*/
        if ((product.quantity ?? 0) <= 0) {
          errorMessages.push(this.$t("stock_mobile.form.error_quantity_gt_zero_for", { name: product.name }));
        }
        if (!((product.unit_price ?? -1) >= 0)) {
          errorMessages.push(this.$t("stock_mobile.form.error_unit_price_gte_zero_for", { name: product.name }));
        }
      });

      if (errorMessages.length > 0) {
        return errorMessages;
      }

      if (this.$v.receptionData.reception_date.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_reception_date_required"));
      }
      if (this.$v.receptionData.partner.uuid.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_supplier_required"));
      }
      if (this.$v.receptionData.warehouse.uuid.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_warehouse_required"));
      }
      return errorMessages;
    },
    goForward() {
      this.currentStep = this.currentStep + 1;
      this.setTitle();
    },
    showProductSelector() {
      this.productSelectorVisibility = true;
    },
    hideProductSelector() {
      this.productSelectorVisibility = false;
    },
    resetForm(fullreset) {
      this.$v.$reset();
      this.receptionData = {
        products: [],
        partner: {
          uuid: "",
          name: "",
          id_number: "",
        },
        warehouse: {
          uuid: "",
          name: "",
        },
        reception_date: this.receptionData.reception_date,
        shipping_note_number: null,
      };

      if (fullreset) {
        this.selectedContracts = [];
        this.selectedPartners = [];
        this.selectedOrders = [];
      }

      this.$refs["receptionInputScroll"].instance.scrollTo(0);
    },
    selectWarehouse() {
      if (this.warehouses.length == 1) {
        this.receptionData.warehouse.uuid = this.warehouses[0].uuid;
        this.receptionData.warehouse.name = this.warehouses[0].name;
      }
    },
    closeTransactions(message) {
      this.$emit("closeTransactions", message);
    },
    showCalendarSelector() {
      this.is_date_selector_visible = !this.is_date_selector_visible;
    },
    calendarDayChosen(data) {
      this.is_date_selector_visible = false;
    },
    onDateSelected(date) {
      this.receptionData.reception_date = date.selectedDate;
    },
    getWarehouseDepartmentByWarehouseUuid(warehouseUuid, search_for_legal_entity_uuid = false) {
      let warehouse = this.warehouses.find((w) => w.uuid == warehouseUuid);
      if (warehouse) {
        return search_for_legal_entity_uuid ? warehouse.legal_entity_uuid : warehouse.department_uuid;
      }
      return null;
    },
    onWarehouseChanged(e) {
      const selectedWarehouse = this.warehouses.find((w) => w.uuid === e.value);

      if (this.selectedContracts.length > 0 && e.value) {
        if (selectedWarehouse) {
          if (
            this.selectedContracts[0].legal_entity_uuid &&
            this.selectedContracts[0].legal_entity_uuid !== selectedWarehouse.legal_entity_uuid
          ) {
            this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_selected_warehouse_legal_entity_mismatch"));
            this.receptionData.warehouse.uuid = null;
            this.receptionData.warehouse.name = null;
            return;
          }
        }
      }

      if (this.selectedOrders.length > 0 && e.value) {
        if (selectedWarehouse) {
          if (
            this.selectedOrders[0].legal_entity_uuid &&
            this.selectedOrders[0].legal_entity_uuid !== selectedWarehouse.legal_entity_uuid
          ) {
            this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_selected_warehouse_legal_entity_mismatch"));
            this.receptionData.warehouse.uuid = null;
            this.receptionData.warehouse.name = null;
            return;
          }
        }
      }
    },
    contractsClick() {
      if (this.selectedOrders.length > 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_cannot_select_contracts_after_orders"));
        return;
      }
      this.currentStep = 2;
      this.setTitle();
    },
    continueFromPartnerSelection() {
      this.currentStep = 0;
      this.setTitle();

      if (this.selectedPartners.length > 0) {
        this.receptionData.partner = {
          uuid: this.selectedPartners[0].uuid,
          name: this.selectedPartners[0].name,
          id_number: this.selectedPartners[0].id_number,
          legal_form: this.selectedPartners[0].legal_form,
        };

        this.receptionData.warehouse.uuid = null;
      }
    },
    async continueFromSelection() {
      this.currentStep = 0;
      this.setTitle();

      if (this.selectedContracts.length > 0) {
        if (!this.measureUnits.length) {
          await this.getMeasureUnits({ enablePagination: 0, limit: 1000 });
        }

        this.selectedContracts.forEach((contract) => {
          if (contract.product_uuid) {
            const exists = this.receptionData.products.some((p) => p.uuid === contract.product_uuid);
            if (!exists) {
              this.receptionData.products.push({
                uuid: contract.product_uuid,
                name: contract.product_name,
                code: contract.product_code,
                barcode: contract.product_barcode,
                measure_unit_id: contract.measure_unit_id,
                measure_unit: this.measureUnits.find((unit) => unit.id === contract.measure_unit_id) || null,
                product_type_uuid: contract.product_type_uuid,
                quantity: 0,
                contract_uuid: contract.uuid,
                unit_price: parseFloat(contract.unit_price_discounted || contract.unit_price || 0),
              });
            }
          }
        });

        this.selectedPartners = [
          {
            uuid: this.selectedContracts[0].partner_uuid,
            name: this.selectedContracts[0].partner_name,
            id_number: this.selectedContracts[0].partner_id_number,
            legal_form: this.selectedContracts[0].partner_legal_form,
          },
        ];

        this.receptionData.partner = {
          uuid: this.selectedContracts[0].partner_uuid,
          name: this.selectedContracts[0].partner_name,
          id_number: this.selectedContracts[0].partner_id_number,
          legal_form: this.selectedContracts[0].partner_legal_form,
        };

        this.receptionData.warehouse.uuid = null;
      }
    },
    partnerClick() {
      if (this.selectedContracts.length > 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_cannot_change_supplier_after_contract"));
        return;
      }

      if (this.selectedOrders.length > 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_cannot_change_supplier_after_order"));
        return;
      }

      this.currentStep = 4;
      this.setTitle();
    },
  },
  mounted() {
    if (!this.measureUnits.length) {
      this.getMeasureUnits({ enablePagination: 0, limit: 1000 });
    }

    this.getGroupByCode({
      code: "STOCK_MANAGEMENT",
    }).then((response) => {
      let _setting = response.items.find((obj) => obj.code == "USE_CURRENT_DATE_ON_CREATION");
      this.preselectDate = _setting?.value == "1";
      if (this.preselectDate) {
        this.receptionData.reception_date = moment().format(this.getDefaultDateFormat);
      }

      // Check GOODS_RECEIPT_WITH_PO_ONLY setting
      let goodsReceiptSetting = response.items.find((obj) => obj.code == "GOODS_RECEIPT_WITH_PO_ONLY");
      this.isOrderSelectionMandatory = goodsReceiptSetting?.value == "1" || goodsReceiptSetting?.value === true;
    });

    this.setTitle();
    this.getWarehouses({
      enablePagination: 0,
      limit: 1000,
      filter: [["is_active", "=", 1]],
    }).then((response) => {
      this.warehouses = response.data;
      this.selectWarehouse();
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/reception.scss";
</style>
